import React, { createContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import Carousel from 'react-bootstrap/Carousel';
import kingdomImg from '../../assets/logo_kingdom_256px.png';
import "react-simple-keyboard/build/css/index.css";
import Pregunta from './Pregunta';
import { Buffer } from 'buffer';
import PreguntaWeb from './PreguntaWeb';
import ModalCargando from '../utilsComponentes/ModalCargando';
import DateConverter from '../Tools/DateConverter'
import ConsultasComunes from '../Sql/ConsultasComunes';
const server = process.env.REACT_APP_SERVER;
export const ContextoRespuesta = createContext();
function EncuestaRespond(props) {
  const { selectFormu, soloVer, teclado, tipo, collback, reg, userResp } = props;
  const [esWeb, setEsWeb] = useState();
  const [idEncuesta, setIdEncuesta] = useState();
  const [regional, setRegional] = useState();
  const [usuario, setUsuario] = useState({});
  const [condicion, setCondicion] = useState('');
  const [obligatorio, setObligatorio] = useState(false);
  const [encuesta, setEncuesta] = useState(null);
  const [preguntas, setPreguntas] = useState([]);
  const [respuestas, setRespuestas] = useState([]);
  const [pregunta, setPregunta] = useState(0);//puntero de las preguntas
  const [respPregunta, setRespPregunta] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [caminoP, setCaminoP] = useState([]);//arreglo de objetos caminos
  const [respondio, setRespondio] = useState(false);
  const [notificar, setNotificar] = useState([]);
  const [loader, setLoader] = useState(false);
  const [valido, setValido] = useState(false);
  const [header, setHeader] = useState(false);
  const mostrarUserLogin = () => {
    var datosUsuario = localStorage.getItem('usuario')
    if (datosUsuario !== undefined && datosUsuario !=null) {
      var info = JSON.parse(localStorage.getItem('usuario'));
      if (info.FOTO != null && info.FOTO != undefined) {
        var imagen = Buffer.from(info.FOTO);
        imagen = imagen.toString('base64');
        var src = 'data:image/jpg;base64,' + imagen;
        return (
          <div className="navbar-brand card flex-row bg-dark m-0 p-0 " >
            <img src={src} width="40" height="40" className=" my-auto rounded-circle card-img-left" />
            <div className='ps-2 my-auto d-none d-sm-inline'>
              <div className="nombreHeader">{info.NOMBREX}</div>
              <div className='cargoHeader'>{info.CARGO}</div>
            </div>
          </div>);
      }
    }
  }
  function hayRespuesta() {
    if (obligatorio) {
      if (respuestas.length !== 0) {
        var resp = respuestas.filter((item) => item.ID_PREGUNTA == respPregunta.ID_PREGUNTA);
        if (resp.length !== 0) {
          return true;
        }
        return false
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function obtenerCaminoInicial(id) {
    var caminoA = []
    for (var i = 0; i < preguntas.length; i++) {
      caminoA.push({ "ACTUAL": preguntas[i].ID_PREGUNTA, "ANT": i == 0 ? null : preguntas[i - 1].ID_PREGUNTA, "NEXT": i == preguntas.length - 1 ? null : preguntas[i + 1].ID_PREGUNTA, "PREG": i, "MOD": false });
    }

    return caminoA.filter((item) => item.ACTUAL == id)[0];
  }
  const cambiarPregunta = (tipo) => {
    if (tipo === 0) {
      if (pregunta !== 0) {
        var infoCamino = caminoP.filter((item) => item.ACTUAL === respPregunta.ID_PREGUNTA)[0];
        var infoCaminoAnt = caminoP.filter((item) => item.ACTUAL === infoCamino.ANT)[0];
        setPregunta(infoCaminoAnt.PREG);
        setRespPregunta(preguntas[infoCaminoAnt.PREG]);
        setObligatorio(preguntas[infoCaminoAnt.PREG].OBLIGATORIO == 'S' ? true : false);
      }
    } else {
      if (pregunta !== preguntas.length - 1) {
        if (hayRespuesta()) {
          var condi = condicion.split('|');
          if (condi[0] === '-1' || condi[0] === '') {
            var infoCamino = caminoP.filter((item) => item.ACTUAL === respPregunta.ID_PREGUNTA)[0];
            var infoCaminoNext = caminoP.filter((item) => item.ACTUAL === infoCamino.NEXT)[0];
            if (infoCamino.MOD) {
              var infoC = obtenerCaminoInicial(infoCamino.ACTUAL);
              var infoCN = obtenerCaminoInicial(infoCamino.NEXT);
              infoCamino.NEXT = infoC.NEXT;
              infoCamino.MOD = false;
              infoCaminoNext.ANT = infoCN.ANT;
              var dato = caminoP.filter((item) => item.ACTUAL !== infoCamino.ACTUAL && item.ACTUAL !== infoCaminoNext.ACTUAL);
              dato.push(infoCamino);
              dato.push(infoCaminoNext);
              setCaminoP(dato);
              infoCaminoNext = caminoP.filter((item) => item.ACTUAL === infoCamino.NEXT)[0];
            }
            setPregunta(infoCaminoNext.PREG);
            setRespPregunta(preguntas[infoCaminoNext.PREG]);
            setObligatorio(preguntas[infoCaminoNext.PREG].OBLIGATORIO == 'S' ? true : false);
          } else if (condi[0] === '0') {
            setModalShow(true);
          } else if (condi[0] === '1') {
            var infoCamino = caminoP.filter((item) => item.ACTUAL === respPregunta.ID_PREGUNTA)[0];
            var infoNext = caminoP.filter((item) => item.ACTUAL == condi[1])[0];
            infoCamino.NEXT = parseInt(condi[1]);
            infoCamino.MOD = true;
            infoNext.ANT = infoCamino.ACTUAL;
            var dato = caminoP.filter((item) => item.ACTUAL !== infoCamino.ACTUAL && item.ACTUAL !== infoNext.ACTUAL);
            dato.push(infoCamino);
            dato.push(infoNext);
            setCaminoP(dato);
            setPregunta(infoNext.PREG);
            setRespPregunta(preguntas[infoNext.PREG]);
            setObligatorio(preguntas[infoNext.PREG].OBLIGATORIO == 'S' ? true : false);
          }
        } else {
          MsgUtils.msgError("Es una pregunta Obligatoria , responde por favor!!");
        }
      }
    }
  }
  function getLoginUser(regional,usuario) {
    fetch(`${server}/sqlComun/getEmpleadoWeb`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional: regional, "idUsuario": usuario
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          console.log(data.ok)
          localStorage.setItem("usuario", JSON.stringify(data.ok));
          setUsuario(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function validarOpciones(opciones, info) {
    var resultado = [];
    if (opciones.length !== 0) {
      for (var i = 0; i < opciones.length; i++) {
        if (opciones[i].ID_ALCANCE !== 0) {
          var valido = false;
          for (var j = 0; j < opciones[i].ALCANCE_VALOR.length; j++) {
            if (opciones[i].ALCANCE_VALOR[j].VALOR == info.EMPRESA_SUCURSAL) {
              valido = true;
              break;
            }
          }
          if (valido) {
            resultado.push(opciones[i]);
          }
        } else {//es para todos
          resultado.push(opciones[i]);
        }
      }
      return resultado;
    } else {
      return resultado;
    }
  }
  function validarMisPreguntas(preguntas, name, esweb) {
    var info = JSON.parse(localStorage.getItem(name));
    var resultado = []
    for (var i = 0; i < preguntas.length; i++) {
      if (preguntas[i].ID_ALCANCE == 0) {//ES PARA TODOS?
        preguntas[i].OPCIONES = validarOpciones(preguntas[i].OPCIONES, info);
        resultado.push(preguntas[i]);
      } else { //tiene filtros
        var valido = false;
        for (var j = 0; j < preguntas[i].ALCANCE_VALOR.length; j++) {
          if (preguntas[i].ALCANCE_VALOR[j].VALOR == info.EMPRESA_SUCURSAL) {
            valido = true;
            break;
          }
        }
        if (valido) {
          preguntas[i].OPCIONES = validarOpciones(preguntas[i].OPCIONES, info);
          resultado.push(preguntas[i]);
        }
      }
    }
    for (var i = 0; i < resultado.length; i++) {
      caminoP.push({ "ACTUAL": preguntas[i].ID_PREGUNTA, "ANT": i == 0 ? null : resultado[i - 1].ID_PREGUNTA, "NEXT": i == resultado.length - 1 ? null : resultado[i + 1].ID_PREGUNTA, "PREG": i, "MOD": false });
    }
    setPreguntas(resultado);
    setRespPregunta(resultado[0]);
    setObligatorio(resultado[0].OBLIGATORIO == 'S' ? true : false);
    setEsWeb(esweb);
    setLoader(false);
  }
  const guardarRespuestas = async () => {
    if (notificar.length != 0) {
      for (var notif of notificar) {
        var result = await ConsultasComunes.sendMsgTelegram({
          ...notif,
          "MENSAJE": `${usuario.NOMBREX} respondio la encuesta: ${encuesta.TITULO}`
        })
      }
    }
    fetch(`${server}/formulario/saveRespuestas`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional, respuestas, preguntas
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          MsgUtils.msgCorrecto("Respuesta Guardada Correctamente");
          setValido(false);
          setRespondio(true);
          setModalShow(false);
          if (tipo == 'F') {
            collback(data.ok);
          }
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function obtenerRespuestasMod(datos) {
    var resultado = []
    for (var dat of datos) {
      dat.DESCRIPCION = UtilsBufer.getText(dat.DESCRIPCION)
      resultado.push(dat)
    }
    return resultado
  }
  const validarEntradaEncuesta = async (dato) => {
    try {
      var url = `${dato[2]}/${dato[3]}/${dato[4]}`
      var result = await ConsultasComunes.cifrarEncuestaurl({ 'regional': dato[6], 'URL': url })
      if (result.ok) {
        var datoReal = result.ok.split('/');
        setRegional(datoReal[1]);
        setIdEncuesta(datoReal[0]);
        fetch(`${server}/formulario/getCuestionario`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            regional: datoReal[1], "ENCUESTA": { "ID_ENCUESTA": datoReal[0] }, "ID_EMPLEADO": datoReal[2]
          })
        })
          .then(res => res.json())
          .then(data => {
            getLoginUser(datoReal[1],datoReal[2]);
            if (data.ok) {
              console.log(data.ok);
              setEncuesta(data.ok.ENCUESTA);
              setNotificar(data.ok.NOTIFICAR);
              if (data.ok.ENCUESTA.RESPONDIO === null) {
                if (data.ok.ENCUESTA.TIENE_CADUCIDAD == 'S') {
                  var fecha = new Date();
                  var ini = new Date(data.ok.ENCUESTA.FECHA_INICIO);
                  var fin = new Date(data.ok.ENCUESTA.FECHA_FIN);
                  if (fecha >= ini && fecha <= fin) {
                    setRespondio(false);
                    setValido(true);
                    validarMisPreguntas(data.ok.PREGUNTAS, 'usuario', true);
                    setHeader(true);
                  } else {
                    setRespondio(false);
                    setValido(false);
                    setLoader(false);
                  }
                } else {
                  setRespondio(false);
                  setValido(true);
                  validarMisPreguntas(data.ok.PREGUNTAS, 'usuario', true);
                  setHeader(true);
                }
              } else {
                setRespondio(true);
                setValido(false);
                setLoader(false);
              }
            } else {
              MsgUtils.msgError(data.error);
            }
          })
          .catch(err => MsgUtils.msgError(err))
      } else {
        MsgUtils.msgError(result.error);
      }
    } catch (error) {
      MsgUtils.msgError(error.message);
    }
  }
  useEffect(() => {
    setLoader(true);
    var dato = window.location.pathname.split('/');
    console.log(dato);
    if (dato.length <= 4) {
      var usur = JSON.parse(localStorage.getItem('info'))
      setRegional(reg);
      setIdEncuesta(selectFormu.ID_ENCUESTA);
      fetch(`${server}/formulario/getCuestionario`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          regional: reg, "ENCUESTA": selectFormu, "ID_EMPLEADO": selectFormu.CREADO_POR
        })
      })
        .then(res => res.json())
        .then(data => {
          if (data.ok) {
            console.log(data.ok);
            if (data.ok.ENCUESTA !== undefined) {
              if (userResp != undefined && userResp != null) {
                setUsuario(userResp);
              } else {
                setUsuario(usur);
              }
              setEncuesta(data.ok.ENCUESTA);
              setRespuestas(obtenerRespuestasMod(data.ok.RESPUESTA));
              setNotificar(data.ok.NOTIFICAR);
              if (data.ok.ENCUESTA.RESPONDIO === null || tipo == 'F') {
                setRespondio(false);
                if (data.ok.ENCUESTA.TIENE_CADUCIDAD == 'S') {
                  var fecha = new Date();
                  var ini = new Date(data.ok.ENCUESTA.FECHA_INICIO);
                  var fin = new Date(data.ok.ENCUESTA.FECHA_FIN);
                  if (fecha >= ini && fecha <= fin) {
                    setValido(true);
                    var esweba = true;
                    if (teclado == true) {
                      esweba = false;
                    }
                    validarMisPreguntas(data.ok.PREGUNTAS, 'info', esweba);
                  } else {
                    setValido(false);
                    setLoader(false);
                  }
                } else {
                  setValido(true);
                  var esweba = true;
                  if (teclado == true) {
                    esweba = false;
                  }
                  validarMisPreguntas(data.ok.PREGUNTAS, 'info', esweba);
                }
              } else {
                setRespondio(true);
                setLoader(false);
              }
            } else {
              setRespondio(false);
              setValido(false);
              setEncuesta(null);
              setLoader(false);
            }
          } else {
            MsgUtils.msgError(data.error);
          }
        })
        .catch(err => MsgUtils.msgError(err));
    } else if (dato.length == 5) {
      setRegional(dato[3]);
      setIdEncuesta(dato[2]);
      fetch(`${server}/formulario/getCuestionario`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          regional: dato[3], "ENCUESTA": { "ID_ENCUESTA": dato[2] }, "ID_EMPLEADO": dato[4]
        })
      })
        .then(res => res.json())
        .then(data => {
          getLoginUser(dato[3],dato[4]);
          if (data.ok) {
            setEncuesta(data.ok.ENCUESTA);
            setNotificar(data.ok.NOTIFICAR);
            if (data.ok.ENCUESTA.RESPONDIO === null) {
              if (data.ok.ENCUESTA.TIENE_CADUCIDAD == 'S') {
                var fecha = new Date();
                var ini = new Date(data.ok.ENCUESTA.FECHA_INICIO);
                var fin = new Date(data.ok.ENCUESTA.FECHA_FIN);
                if (fecha >= ini && fecha <= fin) {
                  setRespondio(false);
                  setValido(true);
                  validarMisPreguntas(data.ok.PREGUNTAS, 'usuario', false);
                } else {
                  setRespondio(false);
                  setValido(false);
                  setLoader(false);
                }
              } else {
                setRespondio(false);
                setValido(true);
                validarMisPreguntas(data.ok.PREGUNTAS, 'usuario', false);
              }
            } else {
              setRespondio(true);
              setValido(false);
              setLoader(false);
            }
          } else {
            MsgUtils.msgError(data.error);
          }
        })
        .catch(err => MsgUtils.msgError(err));
    } else if (dato.length == 7) {
      validarEntradaEncuesta(dato);
    }
  }, [])
  return (
    <ContextoRespuesta.Provider value={{ respuestas, setRespuestas, encuesta, respPregunta, setCondicion, usuario, pregunta }}>
      <ModalCargando show={loader} />
      {esWeb === true && respondio === false && valido &&
        <div>
          {header == true && encuesta != null && <div className='navbar navbar-dark bg-dark m-0 p-0'>
            <div className='container-fluid'>
              <div className="navbar-brand card flex-row bg-dark m-0 p-0" >
                <img src={kingdomImg} alt="" width="40" height="35" className="d-inline-block align-text-top card-img-left my-auto" />
                <div className='ps-2 my-auto text-light'>
                  <div className="cargoHeader ">Chicken's</div>
                  <div className='cargoHeader '>Kingdom</div>
                </div>
              </div>
              <div className='text-light fw-bold fs-6 text-uppercase'>{`Encuesta: ${encuesta.TITULO}`}</div>
              {mostrarUserLogin()}
            </div>
          </div>}
          <Carousel fade={false} controls={false} indicators={false} activeIndex={pregunta}>
            {preguntas.map((item, index) => {
              return (
                <Carousel.Item key={index}>
                  <div className='card m-2' style={{ height: `${window.innerHeight - window.innerHeight * 0.35}px` }} >
                    <div className='card-header m-0 p-0 mx-2'>
                      {`Pregunta: ${index + 1}`}
                    </div>
                    <div className='card-body m-1 '>
                      <div className='fw-bold fs-5 lh-1'>{`${UtilsBufer.getText(item.DESCRIPCION)}`}</div>
                      {item.NOMBRE && <div className='text-center'><img src={`${server}/imagenes/${item.NOMBRE}`} className="card-img-top w-25 mx-auto"></img></div>}
                      <PreguntaWeb item={item} soloVer={soloVer} />
                    </div>
                  </div>
                </Carousel.Item>
              )
            })}
          </Carousel>
          <div className='container-fluid bg-dark bg-gradient'>
            <div className='row row-cols-3 g-1'>
              <div className='col text-center m-0 p-0' style={{ width: '15%' }}>
                <button className='btn btn-sm text-light m-0 p-0'
                  onClick={() => cambiarPregunta(0)} disabled={pregunta == 0 ? true : false}>
                  <i className="bi bi-arrow-left-circle-fill fs-2" ></i>
                </button>
              </div>
              <div className='col my-auto text-light text-center fs-4' style={{ width: '70%' }}>
                {pregunta == preguntas.length - 1 && <button className='btn btn-sm btn-success bg-gradient'
                  onClick={() => { guardarRespuestas() }} disabled={soloVer}>
                  <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar Respuesta
                </button>}
              </div>
              <div className='col text-center' style={{ width: '15%' }}>
                <button className='btn btn-sm text-light m-0 p-0'
                  onClick={() => cambiarPregunta(1)} disabled={pregunta == preguntas.length - 1 ? true : false}>
                  <i className="bi bi-arrow-right-circle-fill fs-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      {esWeb === false && respondio === false && valido &&
        <div className=''>
          {teclado == undefined && <div className='navbar navbar-dark bg-dark m-0 p-0'>
            <div className='container-fluid'>
              <div className="navbar-brand card flex-row bg-dark m-0 p-0" >
                <img src={kingdomImg} alt="" width="40" height="35" className="d-inline-block align-text-top card-img-left my-auto" />
                <div className='ps-2 my-auto text-light'>
                  <div className="cargoHeader ">Chicken's</div>
                  <div className='cargoHeader '>Kingdom</div>
                </div>
              </div>
              <div className='text-light fw-bold fs-6 text-uppercase'>{`Encuesta: ${encuesta.TITULO}`}</div>
              {mostrarUserLogin()}
            </div>
          </div>}
          <Carousel fade={false} controls={false} indicators={false} activeIndex={pregunta}>
            {preguntas.map((item, index) => {
              return (
                <Carousel.Item key={index}>
                  <div className='card m-2' >
                    <div className='card-header m-0 p-0 mx-2'>
                      {`Pregunta: ${index + 1}`}
                    </div>
                    <div className='card-body m-1'>
                      <div className='fs-4 fw-bold'>{`${UtilsBufer.getText(item.DESCRIPCION)}`}</div>
                    </div>
                    {item.NOMBRE && <img src={`${server}/imagenes/${item.NOMBRE}`} className="card-img-top w-25 mx-auto"></img>}
                    <div key={index}>
                      <Pregunta item={item} key={index}/>
                    </div>
                  </div>
                </Carousel.Item>
              )
            })}
          </Carousel>
          <div className='container-fluid bg-dark bg-gradient'>
            <div className='row row-cols-3 g-1'>
              <div className='col text-center m-0 p-0' style={{ width: '15%' }}>
                <button className='btn btn-sm text-light m-0 p-0'
                  onClick={() => cambiarPregunta(0)} disabled={pregunta == 0 ? true : false}>
                  <i className="bi bi-arrow-left-circle-fill fs-2" ></i>
                </button>
              </div>
              <div className='col my-auto text-light text-center fs-4' style={{ width: '70%' }}>
                {pregunta == preguntas.length - 1 && <button className='btn btn-sm btn-success bg-gradient' disabled={soloVer}
                  onClick={() => guardarRespuestas()}>
                  <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar Respuesta
                </button>}
              </div>
              <div className='col text-center' style={{ width: '15%' }}>
                <button className='btn btn-sm text-light m-0 p-0'
                  onClick={() => cambiarPregunta(1)} disabled={pregunta == preguntas.length - 1 ? true : false}>
                  <i className="bi bi-arrow-right-circle-fill fs-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      {respondio === true && valido == false &&
        <div className='container-fluid py-4'>
          <div className="d-flex justify-content-center">
            <div className="col-md-8">
              <div className="card px-5 py-5 bg-warning text-dark" id="form1">
                <div className="card-header text-center">
                  <i className='bi bi-exclamation-octagon-fill fs-4 px-2'></i>
                  <h5>Gracias por Responder !!!</h5>
                </div>
                <div className="card-body m-0 p-0 ">
                  <h5 className="card-title">{`Encuesta: ${encuesta.TITULO}`}</h5>
                  <textarea className='text-dark form-control form-control-sm' style={{ height: '100px' }} disabled value={UtilsBufer.getText(encuesta.DESCRIPCION)}></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {respondio === false && valido === false &&
        <div className='container-fluid py-4'>
          <div className="d-flex justify-content-center">
            <div className="col-md-8">
              <div className="card px-5 py-5 bg-warning text-dark" id="form1">
                <div className="card-header text-center">
                  <i className='bi bi-exclamation-octagon-fill fs-4 px-2'></i>
                  <h5>NO PUEDE RESPONDER EL FORMULARIO</h5>
                </div>
                {encuesta != null && <div className="card-body m-0 p-0 ">
                  <h5 className="card-title">{`Encuesta: ${encuesta.TITULO}`}</h5>
                  <h6 className=''>{`Se tenia que responder antes del ${DateConverter.formatoFecha(encuesta.FECHA_INICIO)} al ${DateConverter.formatoFecha(encuesta.FECHA_FIN)}`} </h6>
                  <textarea className='text-dark form-control form-control-sm' style={{ height: '100px' }}
                    disabled value={UtilsBufer.getText(encuesta.DESCRIPCION)}></textarea>
                </div>}
                {encuesta == null && <div className="card-body m-0 p-0 ">
                  <h5 className='card-title'>Esta encuesta no se encuentra activo o publicado</h5>
                </div>}
              </div>
            </div>
          </div>
        </div>
      }
      <Modal show={modalShow} onHide={() => setModalShow(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName='bg-dark bg-gradient'>
        <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
          <Modal.Title>
            <div className='text-light'>Termino El Formulario</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix='modal-body m-0 p-0'>
          <div className='container-fluid text-center py-4'>
            <button className='btn btn-sm btn-success bg-gradient' onClick={() => guardarRespuestas()}>
              <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar Respuesta
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </ContextoRespuesta.Provider>
  )
}

export default EncuestaRespond
